/* eslint-disable */
// import { InteractionManager } from '../../../../react-native'
import { isSlowDeviceUtil } from '../../../../utils/device/is-slow'

const DELAY = isSlowDeviceUtil()
  ? 300
  : 0

export function runAfterInteractionsPerformanceUntil (func, options) {
  return func(options)
  // return InteractionManager.runAfterInteractions(...arguments)
}

export function requestAnimationFramePerformanceUtil () {
  return requestAnimationFrame(...arguments)
}

export function runAfterDelayPerformanceUtil (callback, options = {}) {
  const delay = options.delay || DELAY
  setTimeout(callback, delay)
}

export function runAfterDelayPromisifiedPerformanceUtil (options) {
  return new Promise(resolve => {
    runAfterDelayPerformanceUtil(resolve, options)
  })
}
